module.exports = "<!-- Application Top Menu -->\n<!-- <top-menu></top-menu> -->\n<!-- Application Main Menu -->\n<admin-header-auth [module]=\"module\"></admin-header-auth>\n<!-- Application Header -->\n<!-- <admin-header [module]=\"module\"></admin-header> -->\n<!-- Application Sidebar -->\n<div class=\"body-auth\">\n    <admin-sidebar [module]=\"module\" *ngIf=\"!toggleSidebar\"></admin-sidebar>\n    <!-- Application Content -->\n    <router-outlet></router-outlet>\n</div>\n<!-- Application Footer -->\n<footer></footer>";


//////////////////
// WEBPACK FOOTER
// ./src/auth/AppComponent.html
// module id = 243
// module chunks = 0